module.exports = __webpack_public_path__ + "img/firebase_icon_132390.2d98664e.svg";